import { useSettings } from "../context/SettingsContext";

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
const RANGES = ["A-B", "C-D", "E-F", "G-H", "I-J", "K-L", "M-N", "O-P", "Q-R", "S-T", "U-V", "W-X", "Y-Z"];

export function LetterBar({ value, onChange }) {
  const { settings } = useSettings();
  const style = settings?.letter_filter_style || "both";
  const rows = [];
  if (style !== "ranges") rows.push(["All", ...LETTERS, "#"]);
  if (style !== "single") rows.push(style === "ranges" ? ["All", ...RANGES, "#"] : RANGES);
  const isActive = (o) => (o === "All" ? !value : value === o.toLowerCase());
  const pick = (o) => onChange(o === "All" ? "" : o.toLowerCase());
  return (
    <div className="w-full min-w-0 space-y-1.5 mb-5" data-testid="letter-bar">
      {rows.map((row, ri) => (
        <div key={row[0] + ri} className="flex flex-wrap gap-1">
          {row.map((o) => (
            <button key={o} onClick={() => pick(o)} data-testid={`letter-${o}`}
              className={`min-w-[30px] px-2 py-1 rounded-md text-xs font-bold border transition-colors ${isActive(o) ? "bg-rose-500 border-rose-500 text-white" : "border-white/10 text-zinc-400 hover:text-white hover:border-rose-500/50"}`}>
              {o}
            </button>
          ))}
        </div>
      ))}
    </div>
  );
}
